import { af } from "../../../../date-fns/locale/af.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    af
  }
};